import { render, staticRenderFns } from "./TopluHacizGonderIslemDetayView.vue?vue&type=template&id=985f83a4&scoped=true"
import script from "./TopluHacizGonderIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./TopluHacizGonderIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985f83a4",
  null
  
)

export default component.exports